import BaseService from './BaseService'
import { cacheManager } from '../utils/CacheManager'

export enum dailyMetricEnum {
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS = 'BUSINESS_IMPRESSIONS_DESKTOP_MAPS',
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH = 'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH',
  BUSINESS_IMPRESSIONS_MOBILE_MAPS = 'BUSINESS_IMPRESSIONS_MOBILE_MAPS',
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH = 'BUSINESS_IMPRESSIONS_MOBILE_SEARCH',
  BUSINESS_CONVERSATIONS = 'BUSINESS_CONVERSATIONS',
  BUSINESS_DIRECTION_REQUESTS = 'BUSINESS_DIRECTION_REQUESTS',
  CALL_CLICKS = 'CALL_CLICKS',
  WEBSITE_CLICKS = 'WEBSITE_CLICKS',
  BUSINESS_BOOKINGS = 'BUSINESS_BOOKINGS',
  BUSINESS_FOOD_ORDERS = 'BUSINESS_FOOD_ORDERS'
}

export interface IGetDailyMetricsTimeSeries {
  timeSeries?: ITimeSeries
}

export interface ITimeSeries {
  datedValues?: IDatedValue[]
}

export interface IDatedValue {
  date?: IDateClass
  value?: string
}

export interface IDateClass {
  year?: number
  month?: number
  day?: number
}

export type GmbMetricsInsights  = { [key in dailyMetricEnum]?: IGetDailyMetricsTimeSeries }

class IntegrationsService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  TikTok = {
    getURL: (locationId: string) =>
      this.requests.get(`/tiktok/oauth/url?locationId=${locationId}`),
    create: (queryData: { [key: string]: any; }) =>
      this.requests.post(`/tiktok/oauth/token`, queryData),
    getAddAccounts: (id: string) =>
      this.requests.get(`/tiktok/${id}/accounts`),
    upsert: (id: string, body: { [key: string]: any; }) =>
      this.requests.put(`/tiktok/${id}`, body),
    delete: (id: string) =>
      this.requests.delete(`/tiktok/${id}`),
    getByLocation: (locationId: string) =>
      this.requests.get(`/tiktok?locationId=${locationId}`),
    getForms: (id: string) =>
      this.requests.get(`/tiktok/${id}/forms`),
    subscribe: (id: string, data: { [key: string]: any }) =>
      this.requests.put(`/tiktok/${id}/subscribe`, data),
    upsertForm: (id: string, formId: string, data: { [key: string]: any }) =>
      this.requests.put(`/tiktok/${id}/forms/${formId}`, data),
  }

  GMB:{ [key: string]: any } = {
    addReviewComment: (reviewId: string, comment: string) => this.requests.post(`/gmb/reviews/${reviewId}/comment`, {comment}),
    checkBusinessScope: (locationId: string) => this.requests.get(`/gmb/oauth/scope/check?locationId=${locationId}`),
    getAccountsLocations: (locationId: string, launchPad: Boolean = false) => {
      const params = {
        locationId,
        launchPad
      }
      return this.requests.get(`/gmb/accounts`, { params })
    },
    getReportInsight: (locationId: string) => {
      const params = {
        locationId
      }
      return this.requests.get(`/gmb/report`, { params })
    },
    getMetricsInsight: (locationId: string):Promise<GmbMetricsInsights> => {
      const params = {
        locationId
      }
      return this.requests.get(`/gmb/metrics`, { params })
    },
    connect: (data: {
      locationId: string,
      gmbLocationId: string,
      gmbLocationName: string,
      gmbPlacesId: string,
      gmbLocationOnlyName: string,
      isVerified: boolean,
      enableCallTracking: boolean,
      launchpad?: boolean,
    }) => {
      return this.requests.post(`/gmb`, {...data, single:true})
    },
    disconnect: (locationId: string) => {
      const data = {
        locationId
      }
      return this.requests.delete(`/gmb`, { data })
    },
    settings: (data: { locationId: string, callTracking?: { enable: boolean}, agent?: {enable: boolean}, agentSetup?: {
      displayName: string
      welcomeMessage: string
      privacyPolicyUrl: string
    }, placesId:string, ignoreMessages?:boolean}) => {
      return this.requests.post(`/gmb/settings`, data)
    },
    updateProfilePicture: (locationId: string, file: any, placesId: string) => {
      const data = new FormData();
      data.append('files', file);

      let query = `locationId=${locationId}`;
      if (placesId) {
        query += `&placesId=${placesId}`;
      }

      return this.requests.post(`/gmb/profilePicture?${query}`, data);
    },
    getLinkedPages: (locationId: string) => {
      return cacheManager.getCachedData(`gmb-linkedPages`, () => this.requests.get(`/gmb/linkedPages?locationId=${locationId}`), {
        key: `gmb-linkedPages-${locationId}`
      })
    },
    disconnectAllPages: (locationId: string) => {
      const data = {
        locationId
      }
      return this.requests.post(`/gmb/disconnect`, { ...data })
    },
  }

  Facebook = {
    syncFBMissingLeads: (locationId: string, pageId: string, syncLeadsTime: number) => this.requests.post(`/facebook/${locationId}/pages/${pageId}/sync-leads`, { timeInDays: syncLeadsTime }),
    getLinkedAdAccount: (locationId: string) => this.requests.get(`/facebook/${locationId}/adAccount`),
    getFBConnection: (locationId: string) => this.requests.get(`/facebook/${locationId}/connection`),
    getAllFbPages: (locationId: string) => this.requests.get(`/facebook/${locationId}/allPages?getAll=true`),
    upsertSelectedFbPage: (locationId: string, data) => this.requests.post(`/facebook/${locationId}/pages`, data),
    getFBConnectedPages: (locationId: string) => this.requests.get(`/facebook/${locationId}/pages?getAll=true`),
  }

  MarketplaceIntegrations = {
    getCustomScripts: (companyId: string) =>this.requests.get(`/custom-script/${companyId}`),

  }

  Google = {
    getAllConnections: (locationId: string) => this.requests.get(`/google/connections?locationId=${locationId}`),
  }
}

const instance = new IntegrationsService(BaseService.servicesConfig.Integrations as string)

export default instance

